module.exports = __webpack_public_path__ + "1280de30cb45a5705602ab2d566d0aed.svg";